export default __webpack_public_path__ + "static/media/fundrising.56be109a.svg";